import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({
  planLimit: {},
  planLimitError: {},
  newImportsErrors: {},
  finishedUploadStatus: {},
  failedUploadStatus: {},
  uploadStatusErrors: {},
  fileUploadResponse: {},
  planUploadedResponse: {},
  gettingUploadStatus: false,
  compareResolutionReponse: {},
  comparingResolution: false,
  pdfThumbnailAsJpeg: {}
})

function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PLANS_LIMIT:
      return state
        .set('projectId', action.projectId)
        .set('plansLimitLoading', true)
        .delete('plansLimit')
        .delete('plansLimitError')
    case actionTypes.GET_PLANS_LIMIT_SUCCEEDED:
      return state
        .set('plansLimit', action.result)
        .delete('plansLimitLoading')
    case actionTypes.GET_PLANS_LIMIT_FAILED:
      return state
        .set('plansLimitError', action.error)
        .delete('plansLimitLoading')

    case actionTypes.FILE_UPLOADED:
      return state.set('fileUploadResponse', {
        ...action.response,
        index: action.index
      })
    case actionTypes.COMPARE_RESOLUTION:
      return state
        .set(
          'compareResolutionStorageId',
          action.storageId || state.get('compareResolutionStorageId')
        )
        .set(
          'compareResolutionPlanId',
          action.planId || state.get('compareResolutionPlanId')
        )
        .delete('compareResolutionError')
    case actionTypes.COMPARE_RESOLUTION_DONE:
      return state
        .set('compareResolutionResponse', { ...action.response })
        .set('comparingResolution', false)
    case actionTypes.COMPARE_RESOLUTION_ERROR:
      return state
        .set('compareResolutionError', action.error)
        .set('comparingResolution', false)
    case actionTypes.COMPARING_RESOLUTION:
      return state.set('comparingResolution', true)
    case actionTypes.CLEAR_COMPARE_RESOLUTION:
      return state
        .set('compareResolutionResponse', {})
        .set('comparingResolution', false)
        .delete('compareResolutionStorageId')
        .delete('compareResolutionPlanId')
    case actionTypes.PLAN_UPLOADED_RESPONSE:
      return state
        .set('planUploadedResponse', action.response)
        .set('compareResolutionResponse', {})
        .set('comparingResolution', false)
    case actionTypes.GET_UPLOAD_STATUS:
      return state.set('gettingUploadStatus', true)
    case actionTypes.UPLOAD_STATUS_RESPONSE:
      return state
        .set('uploadStatus', action.response)
        .set('gettingUploadStatus', false)
    case actionTypes.UPLOAD_ERROR:
      return state.setIn(['newImportsErrors', action.index], action.error)
    case actionTypes.CLEAR_UPLOAD_STATUS:
      return state.set('uploadStatus', [])
    case actionTypes.GET_UPLOAD_STATUS_ERROR:
      return state.setIn(['uploadStatusErrors', action.importId], action.error)
    case actionTypes.SET_CHECKING_UPLOAD_STATUS:
      return state.set('checkingUploadStatus', action.status)

    case actionTypes.UPLOAD_PLAN:
      return state.set('uploadingPlan', true).delete('uploadPlanError')
    case actionTypes.UPLOAD_PLAN_DONE:
      return state.set('uploadingPlan', false)
    case actionTypes.UPLOAD_PLAN_ERROR:
      return state
        .set('uploadingPlan', false)
        .set('uploadPlanError', action.error)

    case actionTypes.GET_PDF_THUMBNAIL_AS_JPEG_DONE:
      return state.setIn(['pdfThumbnailAsJpeg', action.key], action.response)
    case actionTypes.GET_PDF_THUMBNAIL_AS_JPEG_ERROR:
      return state.setIn(['pdfThumbnailAsJpegError', action.key], action.error)

    case actionTypes.UPLOAD_IMAGES:
      return state.set('uploadingImages', true)

    case actionTypes.UPLOAD_IMAGES_DONE:
      return state.set('uploadingImages', false)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
